import cx from "classnames";

import styles from "./Badge.module.scss";

export type BadgeSize = "small" | "medium" | "large";
export type BadgeVariant = "primary" | "secondary" | "tertiary";

interface BadgeProps {
  size: BadgeSize;
  variant: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const Badge = ({
  size,
  variant = "secondary",
  children,
  className,
}: BadgeProps) => {
  return (
    <div className={cx(styles.badge, styles[size], styles[variant], className)}>
      {children}
    </div>
  );
};

export default Badge;
